import * as types from './action-types';
import {getCategories} from '../services/market-api';
import {verticalToMarket} from '../services/utils';

export function requestCategories(categoriesType) {
  return {
    type: types.REQUEST_CATEGORIES,
    categoriesType
  };
}

export function receiveCategories(categoriesType, json, market) {
  return {
    type: types.RECEIVE_CATEGORIES,
    items: json.map(i => i),
    receivedAt: Date.now(),
    categoriesType,
    market
  };
}


export function fetchHomeCategoriesIfNeeded() {
  return (dispatch, getState) => {
    const state = getState();
    const market = verticalToMarket(state.mode.siteProfile.vertical) || 'market_2_0_hp';

    if (state.categories.home.items.length === 0 || state.categories.home.market !== market) {
      dispatch(requestCategories('home'));

      return getCategories(market, state.mode.lang)
        .then(json => dispatch(receiveCategories('home', json, market)))
        .catch(() => dispatch(receiveCategories('home', [])));
    }
  };
}

export function fetchMenuCategoriesIfNeeded() {
  return (dispatch, getState) => {
    const state = getState();

    if (state.categories.menu.items.length === 0) {
      dispatch(requestCategories('menu'));

      // todo remove standalone check after RedirectToOneAppMarket
      return getCategories(state.mode.market === 'standalone' ? 'editor' : 'market_2_0_menu', state.mode.lang)
        .then(json => dispatch(receiveCategories('menu', json)))
        .catch(() => dispatch(receiveCategories('menu', [])));
    }
  };
}

export function openCategory(category) {
  return {
    type: types.OPEN_CATEGORY,
    category
  };
}



// WEBPACK FOOTER //
// ./actions/categories.js